export enum ChipType {
  Enabled = '',
  SingleChoice = 'chip-choice',
  MultiChoice = 'chip-filter',
  Editable = 'chip-input',
  EditableSecondary = 'chip-input-secondary',
  EditableDanger = 'chip-input-danger'
}
